import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import useDataStore from '../Data/dataStore';
import { API } from '../globalUtils';
import Div from '../Page/Div';
import SelectButtons from '../UI/SelectButtons';
import CardSlider from '../UI/CardSlider';
import TeamCard from '../UI/TeamCard';
const TeamSection = ({ content, idx, allowOpen }) => {
    const data = useDataStore((state) => state.data);
    const team = data[API.team]?.team;
    const [activeFilter, setActiveFilter] = useState(null);
    if (!content || !team)
        return _jsx("div", { className: "products-wrapper" });
    const { title, details, display, details_button } = content.team;
    const filter_options = !team
        ? []
        : Array.from(team.reduce((acc, item) => {
            item.categories?.forEach((category) => acc.add(category));
            return acc;
        }, new Set())).map((category) => ({
            name: category
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (c) => c.toUpperCase()),
            category,
        }));
    const isInPage = display === 'in_page';
    const filteredTeam = !team
        ? []
        : !activeFilter
            ? team
            : team.filter((product) => product.categories.includes(activeFilter));
    const getTeam = () => (team ?? []).map((item, idx) => {
        const { image, name, title, link, slug } = item;
        return (_jsx(TeamCard, { name: name, title: title, image: image, index: idx, isHidden: !filteredTeam.includes(item), link: link }, slug));
    });
    return (_jsxs("div", { className: "team-container", children: [_jsx(Div, { className: "team-title", delay: 0, children: title }), filter_options && filter_options.length ? (_jsx(SelectButtons, { options: filter_options, selection: activeFilter ? [activeFilter] : [], onSelection: (item) => setActiveFilter(item) })) : null, _jsx(CardSlider, { isAllowed: allowOpen, children: getTeam() }, "slider")] }));
};
export default TeamSection;
